module.exports = __webpack_public_path__ + "static/Kevin.541708ac.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Kevin.jpg
// module id = 1305
// module chunks = 137408898365125